<template lang="pug">
  div.container-fluid.background-login.vertical-center.px-0
    div.row.d-flex.justify-content-center
      div.col-12.col-sm-12.col-md-6.col-lg-6
        div.card
          div.spinner.spinner-border.spinner-border-lg.text-primary(v-if="authenticating")
          div.card-header
            | Anmeldung
          div.card-body(:class="{ invisible: authenticating }")
            form(@submit.prevent)
              div.form-group
                label(for="email")
                  | E-Mail Adresse
                input.form-control(
                  type="email"
                  id="email"
                  placeholder="Geben Sie Ihre E-Mail Adresse ein"
                  v-model="email"
                  :disabled="authenticating"
                  )
              div.form-group
                label(for="password")
                  | Kennwort
                input.form-control(
                  type="password"
                  id="password"
                  placeholder="Geben Sie Ihr Kennwort ein"
                  v-model="password"
                  :disabled="authenticating"
                  @keyup.enter="login"
                  )
              button.mx-3.btn.btn-primary.btn-lg(
                type="button"
                @click.stop="login"
                :disabled="authenticating"
                )
                | Anmelden
              button.mx-3.btn.btn-secondary(
                type="button"
                @click.stop="showStartPage"
                )
                | Zurück
              div.my-1
                button.btn.btn-link(
                  type="button"
                  @click.stop="forgotPassword"
                  :disabled="authenticating"
                  )
                  | Kennwort vergessen?
          div.card-body.py-0
            div.mt-4.pa-2.alert.invisible(v-if="!authenticating && !showError && !showStudentLink")
              | &nbsp;
            div.mt-4.pa-2.alert.alert-danger(v-if="showError")
              | {{ errorMessage || 'Benutzer oder Kennwort ist nicht korrekt.' }}
            div.mt-4.pa-2.alert.alert-info(v-if="showStudentLink")
              p Sind Sie Student?
              router-link.btn.btn-primary.btn-sm(to="/student-registrierung")
                | Jetzt als Student registrieren
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  name: 'Login',
  data: () => ({
    email: '',
    password: '',
    showError: false,
    errorMessage: '',
    showStudentLink: false
  }),
  computed: {
    ...mapState('authentication', [
      'authenticated'
    ]),
    ...mapGetters('authentication', [
      'authenticating'
    ])
  },
  watch: {
    email () {
      this.clearError()
    },
    password () {
      this.clearError()
    }
  },
  mounted () {
    this.checkAuthentication()
  },
  methods: {
    ...mapMutations('authentication', [
      'setCredentials'
    ]),
    ...mapActions('authentication', [
      'authenticate',
      'checkAuthentication'
    ]),
    ...mapActions('ui', [
      'forgotPassword',
      'showStartPage'
    ]),
    clearError () {
      this.showError = false
      this.errorMessage = ''
      this.showStudentLink = false
    },
    async login () {
      this.clearError()
      this.setCredentials({
        email: this.email,
        password: this.password
      })

      try {
        const success = await this.authenticate()
        if (success) {
          this.$router.replace({ name: 'menu' })
        } else {
          this.showError = true
        }
      } catch (error) {
        this.showError = true

        // Handle student-specific errors
        if (error.message && error.message.includes('student_not_verified')) {
          this.errorMessage = 'Ihr Schülerkonto wurde noch nicht verifiziert. Bitte überprüfen Sie Ihre E-Mails.'
          this.showStudentLink = true
        } else if (error.message && error.message.includes('student_expired')) {
          this.errorMessage = 'Ihre Schülerverifizierung ist abgelaufen. Bitte registrieren Sie sich erneut.'
          this.showStudentLink = true
        } else if (error.message && error.message.includes('student_rejected')) {
          this.errorMessage = 'Ihr Schülerantrag wurde abgelehnt. Bitte kontaktieren Sie uns für weitere Informationen.'
          this.showStudentLink = true
        } else {
          this.errorMessage = 'Benutzer oder Kennwort ist nicht korrekt.'
        }
      }
    }
  }
}
</script>
